var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0078 12C24.0078 5.37258 18.6352 0 12.0078 0C5.38039 0 0.0078125 5.37258 0.0078125 12C0.0078125 17.9895 4.39602 22.954 10.1328 23.8542V15.4688H7.08594V12H10.1328V9.35625C10.1328 6.34875 11.9244 4.6875 14.6654 4.6875C15.9779 4.6875 17.3516 4.92188 17.3516 4.92188V7.875H15.8384C14.3478 7.875 13.8828 8.80008 13.8828 9.75V12H17.2109L16.6789 15.4688H13.8828V23.8542C19.6196 22.954 24.0078 17.9895 24.0078 12Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.0078125)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.010a5598.svg";
export { ForwardRef as ReactComponent };